exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3OpGXe9carBNT4rZlIMpcA {\n    color: black;\n}\n\n.QH9liMovImxo4bBmU-Cui {\n    color: #4183c4;\n}\n\n.oCn56k6WdjzA-z0Rj9OIS {\n    color: #4152c4;\n}\n", ""]);
// Exports
exports.locals = {
	"inactiveLink": "_3OpGXe9carBNT4rZlIMpcA",
	"activeLink": "QH9liMovImxo4bBmU-Cui",
	"activeCamera": "oCn56k6WdjzA-z0Rj9OIS"
};